import { render } from "./AlarmDelete.vue?vue&type=template&id=52cb1cca&ts=true"
import script from "./AlarmDelete.vue?vue&type=script&lang=ts"
export * from "./AlarmDelete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__